import BaseAPI from "@/api/BaseAPI";

export class RegionStageAPI extends BaseAPI {
  constructor() {
    super('/stageData');
  }

  /**
   * @param {Number} uslId
   * @param {1 | 2 | 3} foId
   * @param {Number} regionId
   * */
  getDataStage(uslId = 1, foId = 1, regionId) {
    return this.http.get(`/getDataRegion`, {data: {uslId, regionId, foId}})
  }

  /**
   * @param {FormData} data
   * */

  saveExcelFile(data) {
    return this.http.post(`/import/stage_data_culture`, {data})
  }

  saveExcelFile2(data, founderId) {
    return this.http.post(`/import/stage_data_general?founderId=${founderId}`, {data})
  }


  /**
   * @param {FormData} formData
   * */
  // saveData(rowId = null, stageId = 2, value = null, textVal = '') {
  setDataById(data) {
    return this.http.post(`/setById`, {data})
  }
}

export default new RegionStageAPI()